
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';


function passRouteToProps(route){
	return {
		queryParams: route.query,
		fieldName: route.params.fieldName, 
		fieldValue: route.params.fieldValue
	}
}


let routes = [
	//Dashboard routes


//datadaerah routes

//datajawatan routes

//datapetugas routes
			{
				path: '/datapetugas/:fieldName?/:fieldValue?',
				name: 'datapetugaslist',
				component: () => import('./pages/datapetugas/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/datapetugas/view/:id', 
				name: 'datapetugasview', 
				component: () => import('./pages/datapetugas/view.vue'), 
				props: true
			},
		
			{ 
				path: '/datapetugas/add', 
				name: 'datapetugasadd', 
				component: () => import('./pages/datapetugas/add.vue'), 
				props: true
			},
	
			{ 
				path: '/datapetugas/edit/:id', 
				name: 'datapetugasedit', 
				component: () => import('./pages/datapetugas/edit.vue'), 
				props: true
			},
		
			{ 
				path: '/datapetugas/view_ikthtisas/:id', 
				name: 'datapetugasview_ikthtisas', 
				component: () => import('./pages/datapetugas/view_ikthtisas.vue'), 
				props: true
			},
		
			{ 
				path: '/datapetugas/view_perjalanan/:id', 
				name: 'datapetugasview_perjalanan', 
				component: () => import('./pages/datapetugas/view_perjalanan.vue'), 
				props: true
			},
		
			{ 
				path: '/datapetugas/view_makanbahan/:id', 
				name: 'datapetugasview_makanbahan', 
				component: () => import('./pages/datapetugas/view_makanbahan.vue'), 
				props: true
			},
		

//datapusat routes

//datasekolah routes

//datasukarelawan routes
			{
				path: '/datasukarelawan/:fieldName?/:fieldValue?',
				name: 'datasukarelawanlist',
				component: () => import('./pages/datasukarelawan/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/datasukarelawan/view/:id', 
				name: 'datasukarelawanview', 
				component: () => import('./pages/datasukarelawan/view.vue'), 
				props: true
			},
		
			{ 
				path: '/datasukarelawan/add', 
				name: 'datasukarelawanadd', 
				component: () => import('./pages/datasukarelawan/add.vue'), 
				props: true
			},
	
			{ 
				path: '/datasukarelawan/edit/:id', 
				name: 'datasukarelawanedit', 
				component: () => import('./pages/datasukarelawan/edit.vue'), 
				props: true
			},
		
			{ 
				path: '/datasukarelawan/custom_view/:id', 
				name: 'datasukarelawancustom_view', 
				component: () => import('./pages/datasukarelawan/custom_view.vue'), 
				props: true
			},
		

//permissions routes
			{
				path: '/permissions/:fieldName?/:fieldValue?',
				name: 'permissionslist',
				component: () => import('./pages/permissions/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/permissions/view/:id', 
				name: 'permissionsview', 
				component: () => import('./pages/permissions/view.vue'), 
				props: true
			},
		
			{ 
				path: '/permissions/add', 
				name: 'permissionsadd', 
				component: () => import('./pages/permissions/add.vue'), 
				props: true
			},
	
			{ 
				path: '/permissions/edit/:id', 
				name: 'permissionsedit', 
				component: () => import('./pages/permissions/edit.vue'), 
				props: true
			},
		

//roles routes
			{
				path: '/roles/:fieldName?/:fieldValue?',
				name: 'roleslist',
				component: () => import('./pages/roles/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/roles/view/:id', 
				name: 'rolesview', 
				component: () => import('./pages/roles/view.vue'), 
				props: true
			},
		
			{ 
				path: '/roles/add', 
				name: 'rolesadd', 
				component: () => import('./pages/roles/add.vue'), 
				props: true
			},
	
			{ 
				path: '/roles/edit/:id', 
				name: 'rolesedit', 
				component: () => import('./pages/roles/edit.vue'), 
				props: true
			},
		

//rumusanikhtisas routes
			{
				path: '/rumusanikhtisas/:fieldName?/:fieldValue?',
				name: 'rumusanikhtisaslist',
				component: () => import('./pages/rumusanikhtisas/list.vue'), 
				props: route => passRouteToProps(route)
			},
	

//tbbulan routes

//tbikhtisas routes
			{
				path: '/tbikhtisas/:fieldName?/:fieldValue?',
				name: 'tbikhtisaslist',
				component: () => import('./pages/tbikhtisas/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbikhtisas/view/:id', 
				name: 'tbikhtisasview', 
				component: () => import('./pages/tbikhtisas/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbikhtisas/add', 
				name: 'tbikhtisasadd', 
				component: () => import('./pages/tbikhtisas/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbikhtisas/edit/:id', 
				name: 'tbikhtisasedit', 
				component: () => import('./pages/tbikhtisas/edit.vue'), 
				props: true
			},
		
			{ 
				path: '/tbikhtisas/edit_ikhtisas/:id', 
				name: 'tbikhtisasedit_ikhtisas', 
				component: () => import('./pages/tbikhtisas/edit_ikhtisas.vue'), 
				props: true
			},
		

//tbpep routes
			{
				path: '/tbpep/:fieldName?/:fieldValue?',
				name: 'tbpeplist',
				component: () => import('./pages/tbpep/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbpep/view/:id', 
				name: 'tbpepview', 
				component: () => import('./pages/tbpep/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbpep/add', 
				name: 'tbpepadd', 
				component: () => import('./pages/tbpep/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbpep/edit/:id', 
				name: 'tbpepedit', 
				component: () => import('./pages/tbpep/edit.vue'), 
				props: true
			},
		

//tbstatusborang routes

//tbsukarelawanall routes
			{
				path: '/tbsukarelawanall/:fieldName?/:fieldValue?',
				name: 'tbsukarelawanalllist',
				component: () => import('./pages/tbsukarelawanall/list.vue'), 
				props: route => passRouteToProps(route)
			},
	

//tbtnt routes

//tbtntmakanbahan routes
			{
				path: '/tbtntmakanbahan/:fieldName?/:fieldValue?',
				name: 'tbtntmakanbahanlist',
				component: () => import('./pages/tbtntmakanbahan/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbtntmakanbahan/view/:id', 
				name: 'tbtntmakanbahanview', 
				component: () => import('./pages/tbtntmakanbahan/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbtntmakanbahan/add', 
				name: 'tbtntmakanbahanadd', 
				component: () => import('./pages/tbtntmakanbahan/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbtntmakanbahan/edit/:id', 
				name: 'tbtntmakanbahanedit', 
				component: () => import('./pages/tbtntmakanbahan/edit.vue'), 
				props: true
			},
		
			{ 
				path: '/tbtntmakanbahan/edit_makanbahan/:id', 
				name: 'tbtntmakanbahanedit_makanbahan', 
				component: () => import('./pages/tbtntmakanbahan/edit_makanbahan.vue'), 
				props: true
			},
		

//tbtntperjalanan routes
			{
				path: '/tbtntperjalanan/:fieldName?/:fieldValue?',
				name: 'tbtntperjalananlist',
				component: () => import('./pages/tbtntperjalanan/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbtntperjalanan/view/:id', 
				name: 'tbtntperjalananview', 
				component: () => import('./pages/tbtntperjalanan/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbtntperjalanan/add', 
				name: 'tbtntperjalananadd', 
				component: () => import('./pages/tbtntperjalanan/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbtntperjalanan/edit/:id', 
				name: 'tbtntperjalananedit', 
				component: () => import('./pages/tbtntperjalanan/edit.vue'), 
				props: true
			},
		
			{ 
				path: '/tbtntperjalanan/edit_perjalanan/:id', 
				name: 'tbtntperjalananedit_perjalanan', 
				component: () => import('./pages/tbtntperjalanan/edit_perjalanan.vue'), 
				props: true
			},
		

//tbtntsukarelawan routes
			{
				path: '/tbtntsukarelawan/:fieldName?/:fieldValue?',
				name: 'tbtntsukarelawanlist',
				component: () => import('./pages/tbtntsukarelawan/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tbtntsukarelawan/view/:id', 
				name: 'tbtntsukarelawanview', 
				component: () => import('./pages/tbtntsukarelawan/view.vue'), 
				props: true
			},
		
			{ 
				path: '/tbtntsukarelawan/add', 
				name: 'tbtntsukarelawanadd', 
				component: () => import('./pages/tbtntsukarelawan/add.vue'), 
				props: true
			},
	
			{ 
				path: '/tbtntsukarelawan/edit/:id', 
				name: 'tbtntsukarelawanedit', 
				component: () => import('./pages/tbtntsukarelawan/edit.vue'), 
				props: true
			},
		
			{ 
				path: '/tbtntsukarelawan/custom_edit/:id', 
				name: 'tbtntsukarelawancustom_edit', 
				component: () => import('./pages/tbtntsukarelawan/custom_edit.vue'), 
				props: true
			},
		

//tntikhtisasall routes
			{
				path: '/tntikhtisasall/:fieldName?/:fieldValue?',
				name: 'tntikhtisasalllist',
				component: () => import('./pages/tntikhtisasall/list.vue'), 
				props: route => passRouteToProps(route)
			},
	

//tntmakanbahan routes
			{
				path: '/tntmakanbahan/:fieldName?/:fieldValue?',
				name: 'tntmakanbahanlist',
				component: () => import('./pages/tntmakanbahan/list.vue'), 
				props: route => passRouteToProps(route)
			},
	

//tntperjalananall routes
			{
				path: '/tntperjalananall/:fieldName?/:fieldValue?',
				name: 'tntperjalananalllist',
				component: () => import('./pages/tntperjalananall/list.vue'), 
				props: route => passRouteToProps(route)
			},
	

//tntperjalananantahun routes
			{
				path: '/tntperjalananantahun/:fieldName?/:fieldValue?',
				name: 'tntperjalananantahunlist',
				component: () => import('./pages/tntperjalananantahun/list.vue'), 
				props: route => passRouteToProps(route)
			},
	

//tntpetugas routes
			{
				path: '/tntpetugas/:fieldName?/:fieldValue?',
				name: 'tntpetugaslist',
				component: () => import('./pages/tntpetugas/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/tntpetugas/view/:id', 
				name: 'tntpetugasview', 
				component: () => import('./pages/tntpetugas/view.vue'), 
				props: true
			},
		

//users routes
			{
				path: '/users/:fieldName?/:fieldValue?',
				name: 'userslist',
				component: () => import('./pages/users/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/users/view/:id', 
				name: 'usersview', 
				component: () => import('./pages/users/view.vue'), 
				props: true
			},
		
			{ 
				path: '/account/edit', 
				name: 'usersaccountedit', 
				component: () => import('./pages/account/accountedit.vue'), 
				props: true
			},
	
			{ 
				path: '/account', 
				name: 'usersaccountview', 
				component: () => import('./pages/account/accountview.vue'), 
				props: true
			},
	
			{ 
				path: '/users/add', 
				name: 'usersadd', 
				component: () => import('./pages/users/add.vue'), 
				props: true
			},
	
			{ 
				path: '/users/edit/:id', 
				name: 'usersedit', 
				component: () => import('./pages/users/edit.vue'), 
				props: true
			},
		

			{ 
				path: '/admin_akses', 
				name: 'admin_akses', 
				component: () => import('././pages/custom/admin_akses.vue'), 
				props: true
			},
	
	
	
	
	
	{ 
		path:  '/error/forbidden', 
		name: 'forbidden', 
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{ 
		path: '/error/notfound', 
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)', 
		component: () => import('./pages/errors/pagenotfound.vue')
	}
];

export default () => {
	
const auth = useAuth();

	
	const user = auth.user;
	if(user){
		const roleName = auth.userRole.toLowerCase();
		let rolePage;
		switch(roleName){
			case "ppd":
				rolePage = "ppd";
				break;
			default:
				rolePage = "home";
		}
		
		//Dashboard route
		//Display page based on user role
		routes.push({
			path: '/',
			alias: '/home', 
			name: 'home', 
			component: () => import(`./pages/home/${rolePage}.vue`),
			props: true
		});
	}
	else{
		routes.push({
			path: '/', 
			alias: '/index', 
			name: 'index', 
			component: () => import('./pages/index/index.vue'),
			props: true
		});
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion){
			if(savedPostion) return savedPostion;
			return { top:0 }
		}
	});
	
	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);
		if (authRequired) {
			if(!user){
				return next({ path: '/',  query: { nexturl: to.fullPath } });
			}
			//authorize user
			if (!auth.canView(path)) {
				return next({path: "/error/forbidden"});
			}
		}

		if(user && to.name == "index"){
			//already logged in, show home when try to access index page
			return next({ path: "/home"});
		}

		//navigate to redirect url if available
		if(to.name == "home" && to.query.nexturl){
			return next({ path: to.query.nexturl});
		}

 		//close dialog from previous page
		//store.closeDialogs('app/closeDialogs');
		
		next();
	});

	return router;
}
